const GRID_SIZE = 5;

type FrozenRatingPadProps = {
  attitudeScore: number;
  logicScore: number;
};

export function FrozenRatingPad({ attitudeScore, logicScore }: FrozenRatingPadProps) {
  return (
    <div className="frozen-grid-panel" aria-hidden="true">
      <span className="grid-axis-label grid-axis-top">有道理</span>
      <span className="grid-axis-label grid-axis-bottom">没道理</span>
      <span className="grid-axis-label grid-axis-left">不认同</span>
      <span className="grid-axis-label grid-axis-right">认同</span>
      <div className="grid-5x5 grid-5x5--frozen">
        {Array.from({ length: GRID_SIZE }, (_, row) =>
          Array.from({ length: GRID_SIZE }, (_, col) => {
            const cellLogic = GRID_SIZE - row;
            const cellAttitude = col + 1;
            const isActive = cellAttitude === attitudeScore && cellLogic === logicScore;
            return (
              <div
                key={`${row}-${col}`}
                className={`grid-cell${isActive ? " is-active is-frozen" : ""}`}
              />
            );
          })
        )}
      </div>
    </div>
  );
}
